<template>
  <div class="cm-pagination">
    <div class="cm-pagination__pagination">
      <button
        :disabled="currentPage < 1"
        class="pagination__btn"
        @click="currentPage -= 1"
      >&lt;</button>
      <button
        v-for="(btn, btnIndex) in btns"
        :key="btnIndex"
        :disabled="activeIndex === btnIndex"
        :class="[
          'pagination__btn',
          { 'pagination__btn--active': activeIndex === btnIndex }]"
        @click="setCurrentPage(btn)">
        {{ btn + 1 }}
      </button>
      <button
        :disabled="currentPage + 2 > chunksQty"
        class="pagination__btn"
        @click="currentPage += 1"
      >&gt;</button>
    </div>
    <span class="cm-pagination__page-num-info">
     {{ bottomText }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    visibilityBottomText: {
      type: Boolean,
      default: true
    },
    count: {
      default: 1
    },
    countPerChunk: {
      type: Number,
      default: 10
    },
    activePage: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      currentPage: 0
    }
  },

  computed: {
    chunksQty() {
      if (this.countPerChunk >= this.count) {
        return 1;
      }
      if (this.countPerChunk * 2 > this.count) {
        return 2;
      }
      return Math.ceil(this.count / this.countPerChunk);
    },

    bottomText() {
      const from = this.activePage * this.countPerChunk + 1;
      const to = from + this.countPerChunk - 1;
      return `${this.fNum.format(+from)} - ${this.fNum.format(to > this.count ? this.count : to)} (из ${this.fNum.format(this.count)})`;
    },

    activeIndex() {
      if (this.chunksQty === 2 && this.activePage === 1) {
        return 1;
      }

      if (this.activePage === 0) {
        return 0;
      }

      if (this.chunksQty - 1 === this.activePage) {
        return 2;
      }
      return 1;
    },

    btns() {
      if (this.chunksQty === 1) {
        return [0];
      }

      if (this.chunksQty === 2) {
        return [0, 1];
      }

      if (this.activeIndex === 0) {
        return [this.currentPage, this.currentPage + 1, this.currentPage + 2];
      }

      if (this.activeIndex === 2) {
        return [this.currentPage - 2, this.currentPage - 1, this.currentPage];
      }

      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    }
  },

  mounted() {
    this.currentPage = this.activePage;
  },

  watch: {
    currentPage(value) {
      this.$emit("update:activePage", value);
    },
    activePage(value) {
      this.currentPage = value;
    }
  },

  methods: {
    setCurrentPage(index) {
      if (this.chunksQty <= 3) {
        this.currentPage = index;
        return;
      }

      if (index === 0) {
        this.currentPage = this.currentPage - 1;
        return;
      }

      if (index === 2 && this.activeIndex === 0) {
         this.currentPage = this.currentPage + 2;
         return;
      }

      if (index === 1 && this.activeIndex === 2) {
         this.currentPage = this.currentPage - 2;
         return;
      }

      this.currentPage = index;
    }
  }
}
</script>

<style lang="scss">
.cm-pagination {
  display: flex;
  align-items: center;
  margin-top: 27px;

  &__page-num-info {
    margin-left: 25px;
    white-space: nowrap;
  }

  &__pagination {
    border: 1px solid #e8e8e8;
    display: flex;
    width: fit-content;

    .pagination {
      &__btn {
        background: $color_white;
        box-shadow: none;
        border-radius: 0;
        box-sizing: border-box;
        color: rgba(#000000, 0.4);
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        padding: 0;
        margin: 0;
        text-align: center;
        height: 31px;
        width: 48px;
        transition: opacity 0.3s ease;

        &:not(:last-of-type) {
          border-right: 1px solid #e8e8e8;
        }

        &--active {
          background: $color_green_new;
          color: $color_white;
          opacity: 1;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
